import { Component, Element, h, Prop, Watch } from '@stencil/core';
import { SubscribeConsumerEventData } from '../consumer/consumer';

/**
 * @slot - Elements that can consume the context.
 */
@Component({
  tag: 'sy-context-provider',
  shadow: true,
})
export class ContextProvider {
  private consumersSet = new Set<any>();
  private consumersListener;

  @Element() el: HTMLSyContextProviderElement;

  /**
   * Context identifier
   */
  @Prop({ reflect: true }) context: string;

  /**
   * Context value
   */
  @Prop() value: any;

  @Watch('value')
  valueWatcher(): void {
    this.consumersSet.forEach((el) => {
      el.changeValue(this.value);
    });
  }

  connectedCallback() {
    this.consumersListener = (e: CustomEvent<SubscribeConsumerEventData>) => {
      if (e?.detail?.context === this.context) {
        e.stopPropagation();

        if (e.detail.el && !e.detail.el.unsubscribe) {
          this.consumersSet.add(e.detail.el);
          e.detail.el.changeValue(this.value);
          e.detail.el.unsubscribe = () => {
            this.consumersSet.delete(e.detail.el);
            e.detail.el.unsubscribe = null;
          };
        }
      }
    };
    this.el.addEventListener('syContextConsumerDidSubscribe', this.consumersListener);
  }

  disconnectedCallback() {
    this.consumersListener && this.el.removeEventListener('syContextConsumerDidSubscribe', this.consumersListener);
  }

  render() {
    return <slot />;
  }
}
